import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import { Grid, IconButton, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {
  useAllUsersExportMutation,
  useConvertUserToAgentAccountMutation,
  useUsersListQuery,
} from "api/users/users.mutation";
import ExcelIcon from "assets/admin/excel.svg";
import SearchField from "components/SearchField";
import { Table } from "components/Table";
import { exportToExcel } from "constants/export";
import { handleError } from "functions/apiHandleError";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CreateUpgradeUserModal } from "./createUpgradeModal";
import classes from "./style.module.scss";

const Users = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const paramPage = Number(searchParams.get("page")) || 1;

  const [loading, setLoading] = useState();
  const [pageFilter, setPageFilter] = useState({
    page: paramPage,
    page_size: 15,
    total: 1,
    count: 0,
  });
  const [searchValue, setSearchValue] = useState("");
  const [upgradeUserModal, setUpgradeUserModal] = useState({ open: false, selectedUser: null });

  const usersQuery = useUsersListQuery({
    page: pageFilter.page,
    page_size: pageFilter.page_size,
    search: searchValue,
  });
  const convertUserToAgentMutation = useConvertUserToAgentAccountMutation();
  const tableData = usersQuery.data?.results ?? [];
  const tableLoading = loading || usersQuery.isFetching || convertUserToAgentMutation.isPending;
  const totalPages = usersQuery.data?.total ?? pageFilter.total;
  const exportUsersMutation = useAllUsersExportMutation();

  const handleExportExcel = () => {
    exportUsersMutation.mutate(undefined, {
      onSuccess: (res) => {
        const allRows = Array.isArray(res) ? res : res?.results ?? [];

        exportToExcel(columns, allRows, "users.xlsx");
      },
    });
  };

  const ConvertUserToAgentAccount = async (pk) => {
    setLoading(true);
    try {
      await convertUserToAgentMutation.mutateAsync(pk);
      toast.success("با موفقیت انجام شد");
    } catch (err) {
      handleError({ err });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (pageFilter.page !== paramPage) {
      setPageFilter((prev) => ({
        ...prev,
        page: paramPage,
      }));
    }
  }, [paramPage]);

  const handleOpenCreateUpgradeModal = (selectedUser) => {
    setUpgradeUserModal({
      open: true,
      selectedUser,
    });
  };

  const handleCloseCreateUpgradeModal = () => {
    setUpgradeUserModal({
      open: false,
      selectedUser: null,
    });
  };

  const columns = [
    {
      field: "username",
      headerName: "نام و نام خانوادگی ",
      minWidth: 320,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) => `${row?.profile?.first_name ?? ""} ${row?.profile?.last_name ?? ""}`,
    },
    {
      field: "email",
      headerName: "ایمیل",
      minWidth: 220,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "birth_date",
      headerName: "تاریخ تولد",
      maxWidth: 150,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) => row?.profile?.birth_date ?? "",
    },
    {
      field: "passport_number",
      headerName: "شماره پاسپورت",
      maxWidth: 150,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) => row?.profile?.passport_number ?? "",
    },
    {
      field: "applications_count",
      headerName: "تعداد پرونده ها",
      maxWidth: 150,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "action",
      headerName: "مدیریت حساب",
      maxWidth: 200,
      flex: 1,
      sortable: false,
      resizable: false,
      hideInExport: true,
      renderCell: ({ row }) => (
        <Stack spacing={1} direction="row">
          <Tooltip title="تبدیل به ایجنت">
            <IconButton color="success" onClick={() => handleOpenCreateUpgradeModal(row)}>
              <UpgradeIcon fontSize="medium" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
    {
      field: "applications",
      headerName: "اپلیکیشن ها",
      maxWidth: 180,
      flex: 1,
      sortable: false,
      resizable: false,
      hideInExport: true,
      renderCell: ({ row }) => (
        <Tooltip title="مشاهده اپلیکیشن ها">
          <div
            className={classes.nextBox}
            onClick={() => navigate(`/dashboard/my-referral-applications?email=${row?.email}`)}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </div>
        </Tooltip>
      ),
    },
  ];
  return (
    <>
      <div className={classes.mainDiv}>
        <div className={classes.toolBar}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <SearchField setValueCallback={setSearchValue} variant="standard" />
            </Grid>
            <Grid item xs={0} md={4} />
            <Grid item xs={12} md={4}>
              <div className={classes.manageBar}>
                <Tooltip title="خروجی اکسل">
                  <IconButton
                    onClick={handleExportExcel}
                    color="success"
                    disabled={exportUsersMutation.isPending}
                  >
                    <img src={ExcelIcon} alt="export-excell" className={classes.customIcon} />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
          </Grid>
        </div>
        <Table
          rows={tableData}
          columns={columns}
          totalPages={totalPages}
          loading={tableLoading}
          className={classes.tableContainer}
        />
      </div>
      <CreateUpgradeUserModal
        open={upgradeUserModal?.open}
        onClose={handleCloseCreateUpgradeModal}
        selectedUser={upgradeUserModal?.selectedUser}
        onConfirm={ConvertUserToAgentAccount}
      />
    </>
  );
};

export default Users;
